<template>
    <el-dialog :title="titleVale" v-model="dialogVisible" width="30%"  :before-close="handleClose">
        <div class="content-cs">
            <el-form :model="form" :rules="rules" ref="ruleForm" >
                <el-form-item label="考试:" prop="title" label-width="100px">
                    <el-input v-model="form.title" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="班级" prop="classes" label-width="100px">
                <el-select filterable v-model="form.classes" placeholder="请选择年级" @change="classClick">
                    <el-option :label="item.name" :value="item.id" v-for="item in gradeDataList" :key="item.value"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="" prop="classes2" label-width="100px">
                <el-select v-model="form.classes2" filterable placeholder="请选择班级">
                    <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="姓名:" prop="" label-width="100px">
                    <el-input v-model="form.studentName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="学号:" prop="" label-width="100px">
                    <el-input v-model="form.studentNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="年级排名:" prop="" label-width="100px">
                    <el-input v-model="form.gradeRankNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="语文:" prop="" label-width="100px">
                    <el-input v-model="form.courseScore1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数学:" prop="" label-width="100px">
                    <el-input v-model="form.courseScore2" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="英语:" prop="" label-width="100px">
                    <el-input v-model="form.courseScore3" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="科学:" prop="" label-width="100px">
                    <el-input v-model="form.courseScore4" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="历社:" prop="" label-width="100px">
                    <el-input v-model="form.courseScore5" autocomplete="off"></el-input>
                </el-form-item>
        
                <div class="buttom-box">
                    <el-button type="primary" class="Tijiao" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
            </el-form>
        </div>
    </el-dialog>
</template>
<script>
import { examScoreUpdate} from '@/assets/api/schoollog'
import { gradeList, findClassList } from '@/assets/api/renyuan';
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['reviseItem','objLookTeacher'],
    data() {

        return {

            dialogVisible: true,
            title: '',
            form: {
                title: '',
                classes: '',
                classes2: '',
                studentName: '',
                studentNo: '',
                gradeRankNo: '',
                courseScore1: '',
                courseScore2: '',
                courseScore3: '',
                courseScore4: '',
                courseScore5: '',
            },
            cardid: "",
            schoolList: [],
            titleVale: '',
            rules: {
                type: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ],
                userName: [
                    { required: true, message: '请选择所属用户', trigger: 'change' }
                ],
                addTime: [
                    { required: true, message: '发布时间', trigger: 'change' }
                ],
                textValue: [
                    { required: true, message: '发布文本内容', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '标题', trigger: 'change' }
                ],
            },
            tempFile: '',
            picImage:'',
            fileShow: true,
            classList: [],
            gradeDataList: [],
        }
    },
    created() {
        this.schoolClick()
    },
    mounted() {
        if ( JSON.stringify(this.reviseItem) != '{}' ) {
            this.titleVale = '修改信息'
            this.form.title = this.reviseItem.courseName
            this.form.classes = this.reviseItem.gradeId
            let params = {
                page: '1',
                pageSize: '999',
            }
            findClassList(params, this.form.classes).then((res) => {
                console.log(res, '班级列表');
                this.classList = res.data.data.list
                this.form.classes2 = this.reviseItem.clazzId
            }).catch((err) => {
                console.log(err);
            })
            this.form.studentName = this.reviseItem.studentName
            this.form.studentNo = this.reviseItem.studentNo
            this.form.gradeRankNo = this.reviseItem.gradeRankNo
            this.form.courseScore1 = this.reviseItem.courseScore1
            this.form.courseScore2 = this.reviseItem.courseScore2
            this.form.courseScore3 = this.reviseItem.courseScore3
            this.form.courseScore4 = this.reviseItem.courseScore4
            this.form.courseScore5 = this.reviseItem.courseScore5
        } else {
            this.titleVale = '发布作业'
        }
    },
    methods: {
        chufa () {
            console.log('测试4556');
        },
        shangchuan () {
            // this.$refs.inputFile.getFile($event)
            document.getElementById("inputFile").click();
            console.log(document.getElementById("inputFile"));
            // this.$refs.inputFile.click()
        },
    
        handleClose() {
            this.$emit('backClick')
        },
        submitForm(ruleForm) {
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.addClick()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        addClick() {
            console.log('提交');
            if ( JSON.stringify(this.reviseItem) != '{}' ) {
                let params = {
                    clazzRankNo: this.form.gradeRankNo,
                    courseScore1: this.form.courseScore1,
                    courseScore2: this.form.courseScore2,
                    courseScore3: this.form.courseScore3,
                    courseScore4: this.form.courseScore4,
                    courseScore5: this.form.courseScore5,
                    gradeRankNo: this.form.gradeRankNo,
                    id: this.reviseItem.id,
                    clazzRankNo: this.reviseItem.clazzRankNo,
                }
                examScoreUpdate(params ).then((res) => {
                    console.log(res);
                    this.$message({
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.handleClose()
                }).catch((err) => {
                    this.$message.error('发布信息失败');
                })
            } 

        },
        schoolClick() {
        this.form.classes = ''
        this.form.classes2 = ''
        let params = {
          page: '1',
          pageSize: '999',
        }
        // this.objLookTeacher.schoolId
        gradeList(params, 'ecf75056cbb9701bccbc8ae96a30e8e0').then((res) => {
          console.log(res, '年级列表');
          this.gradeDataList = res.data.data;
        }).catch((err) => {
          console.log(err);
        })
      },
      classClick() {
        this.form.classes2 = ''
        let params = {
          page: '1',
          pageSize: '999',
        }
        findClassList(params, this.form.classes).then((res) => {
          console.log(res, '班级列表');
          this.classList = res.data.data;
        }).catch((err) => {
          console.log(err);
        })
      },
    }
}




</script>
<style  scoped lang="scss">
.content-cs {
    height: 350px;
    overflow: auto;
}
.Tijiao {
    // background-color: #1BC896;
}

/deep/ {
    .el-form {
        height:350px ;
        overflow: auto;
    }
    .el-input--small .el-input__wrapper {
        height: 35px;
        line-height: 35px;
        text-align: center;
        width: 280px;
    }

    .el-input__inner {
        // width: 10px !important;
    }

    .buttom-box {
        // text-align: center;
        margin-left: 180px;

    }

    .el-form-item--small {
        width: 70% !important;
    }

    .el-button--small {
        width: 60px !important;
        height: 35px !important;
        // color: #1BC896;


    }

    .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
    }
}
   
</style>